import { render, staticRenderFns } from "./TokenScaduto.vue?vue&type=template&id=4ae51858&scoped=true&"
import script from "./TokenScaduto.vue?vue&type=script&lang=js&"
export * from "./TokenScaduto.vue?vue&type=script&lang=js&"
import style0 from "./TokenScaduto.vue?vue&type=style&index=0&id=4ae51858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae51858",
  null
  
)

export default component.exports